import ServiceExec from '@/common/utils/ServiceExec';
import { law } from '@/common/service/apiList';
import { fileRequestBinding } from '@/common/utils/module/FormattingSupport';
import { cloneDeep } from 'lodash';
import { asFormData } from '@/common/utils/module/FormDataSupport';

export default {
  getLawList: async function({ commit, getters }) {
    const condition = getters['getCondition'];
    const { data, status } = await ServiceExec.get(law.getList, condition);
    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;
    if (condition.page > pageInfo.totalPage) return false;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setLawList', list ?? []);
  },

  async applyLaw({ commit, getters }, payload) {
    const reqData = cloneDeep(payload);
    fileRequestBinding(reqData);

    const formData = asFormData(reqData);
    const { status } = await ServiceExec.multiPost(law.applyLaw, formData);
    return ServiceExec.status.OK === status;
  }
};
